import React from 'react';
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import ErrorBoundary from 'canopy-react-error-boundary';
import SaveToCanopyFilesDropdown from 'src/documents/save-to-canopy-files-dropdown/save-to-canopy-files-dropdown.component';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: ErrorBoundary({ featureName: 'docs-ui_save-to-canopy-files-dropdown_parcel' })(SaveToCanopyFilesDropdown)
})

const featureToggles = ['toggle_file_attachments'];

const bootstrap = [
  () => {
    if (!!featureToggles.length) {
      return SystemJS.import('feature-toggles!sofe').then(ft => ft.fetchFeatureToggles(...featureToggles))
    } else {
      return Promise.resolve();
    }
  },
  reactLifecycles.bootstrap,
]

export const SaveToCanopyFilesDropdownParcel = {
  ...reactLifecycles,
  bootstrap,
}
